import React from "react";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined } from "us.icons";
import { $Popconfirm } from "us.common/components";
import { ItemTypeAction } from "../../Interfaces";

interface IItemMenu {
  actions?: ItemTypeAction[];
  onCallAction: (actionType: ItemTypeAction) => void;
}

/**
 * @description - Item types table action menu.
 * @link Design Document - https://unicorn-solutions.atlassian.net/wiki/spaces/USU/pages/2992242726/Manage+Item+Types+-+UI+Implementation
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 20/06/2022
 */
const ItemMenu: React.FC<IItemMenu> = ({
  actions = [
    ItemTypeAction.EDIT,
    ItemTypeAction.DELETE,
  ],
  onCallAction,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-more-content" data-testid="popover-content">
      {actions.includes(ItemTypeAction.EDIT) && (
        <div
          className="d-flex  flex-row more-item"
          data-testid="edit-btn"
          onClick={() => onCallAction(ItemTypeAction.EDIT)}
        >
          <div className="p-1">
            <EditOutlined />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.EDIT")}</div>
        </div>
      )}

      {actions.includes(ItemTypeAction.DELETE) && (
        <$Popconfirm
          title={t("US.COLLECTION.COMMON:COMMON.SURE_TO_DELETE_?")}
          data-testid="popUpConfirm-box"
          onConfirm={() => onCallAction(ItemTypeAction.DELETE)}
        >
          <div
            className="d-flex mb-2 flex-row more-item text-error"
            data-testid="delete-btn"
          >
            <div className="p-1">
              <DeleteOutlined />
            </div>
            <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.DELETE")}</div>
          </div>
        </$Popconfirm>
      )}
    </div>
  );
};

export default ItemMenu;